/**
 * אייקוני SVG ידידותיים — אחידים ומותאמים ל-RTL.
 * גודל ברירת מחדל 20x20; ניתן לדרוס עם className ו־style.
 */
const defaultSize = 20

function IconWrapper({ size = defaultSize, className, style, children, ...rest }) {
  return (
    <span
      className={`icon-svg ${className || ''}`.trim()}
      style={{ display: 'inline-flex', width: size, height: size, ...style }}
      {...rest}
    >
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
        {children}
      </svg>
    </span>
  )
}

export function IconClose({ size, className, style }) {
  return (
    <IconWrapper size={size} className={className} style={style}>
      <path d="M18 6L6 18M6 6l12 12" />
    </IconWrapper>
  )
}

export function IconUndo({ size, className, style }) {
  return (
    <IconWrapper size={size} className={className} style={style}>
      <path d="M3 10h10a5 5 0 0 1 5 5v2M3 10l4-4M3 10l4 4" />
    </IconWrapper>
  )
}

export function IconRedo({ size, className, style }) {
  return (
    <IconWrapper size={size} className={className} style={style}>
      <path d="M21 10H11a5 5 0 0 0-5 5v2M21 10l-4-4M21 10l-4 4" />
    </IconWrapper>
  )
}

export function IconMenu({ size, className, style }) {
  return (
    <IconWrapper size={size} className={className} style={style}>
      <line x1="4" y1="6" x2="20" y2="6" />
      <line x1="4" y1="12" x2="20" y2="12" />
      <line x1="4" y1="18" x2="20" y2="18" />
    </IconWrapper>
  )
}

export function IconCheck({ size, className, style }) {
  return (
    <IconWrapper size={size} className={className} style={style}>
      <polyline points="20 6 9 17 4 12" />
    </IconWrapper>
  )
}

export function IconDownload({ size, className, style }) {
  return (
    <IconWrapper size={size} className={className} style={style}>
      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
      <polyline points="7 10 12 15 17 10" />
      <line x1="12" y1="15" x2="12" y2="3" />
    </IconWrapper>
  )
}

export function IconDelete({ size, className, style }) {
  return (
    <IconWrapper size={size} className={className} style={style}>
      <polyline points="3 6 5 6 21 6" />
      <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
      <line x1="10" y1="11" x2="10" y2="17" />
      <line x1="14" y1="11" x2="14" y2="17" />
    </IconWrapper>
  )
}

export function IconPlus({ size, className, style }) {
  return (
    <IconWrapper size={size} className={className} style={style}>
      <line x1="12" y1="5" x2="12" y2="19" />
      <line x1="5" y1="12" x2="19" y2="12" />
    </IconWrapper>
  )
}

/** פלוס עם ניצנוצים - למעבר ממצב ילד לתפריט מורכב */
export function IconPlusSparkles({ size, className, style }) {
  return (
    <IconWrapper size={size} className={className} style={style}>
      <line x1="12" y1="6" x2="12" y2="18" />
      <line x1="6" y1="12" x2="18" y2="12" />
      <circle cx="6" cy="6" r="1.2" fill="currentColor" />
      <circle cx="18" cy="6" r="1.2" fill="currentColor" />
      <circle cx="18" cy="18" r="1.2" fill="currentColor" />
      <circle cx="6" cy="18" r="1.2" fill="currentColor" />
    </IconWrapper>
  )
}

export function IconHome({ size, className, style }) {
  return (
    <IconWrapper size={size} className={className} style={style}>
      <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
      <polyline points="9 22 9 12 15 12 15 22" />
    </IconWrapper>
  )
}

export function IconSpeaker({ size, className, style }) {
  return (
    <IconWrapper size={size} className={className} style={style}>
      <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5" />
      <path d="M15.54 8.46a5 5 0 0 1 0 7.07M19.07 4.93a10 10 0 0 1 0 14.14" />
    </IconWrapper>
  )
}

export function IconEye({ size, className, style }) {
  return (
    <IconWrapper size={size} className={className} style={style}>
      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
      <circle cx="12" cy="12" r="3" />
    </IconWrapper>
  )
}

export function IconBrush({ size, className, style }) {
  return (
    <IconWrapper size={size} className={className} style={style}>
      <path d="M9.06 11.9L3 18v3h3l6.06-6.06" />
      <path d="M21 12.5a3.5 3.5 0 0 1-4.95 3.16l-1.12-1.12 5.66-5.66a3.5 3.5 0 0 1 .41-4.5" />
    </IconWrapper>
  )
}

/** גומייה — מוחק צבע (חוזר לרקע לבן של הדף) */
export function IconEraser({ size, className, style }) {
  return (
    <IconWrapper size={size} className={className} style={style}>
      <path d="m7.5 13.5 6.5-6.5 5 5-6.5 6.5a2 2 0 0 1-2.83 0l-3.67-3.67a2 2 0 0 1 0-2.83z" />
      <path d="m18 2 4 4" />
      <path d="M9 22h8" />
    </IconWrapper>
  )
}

export function IconFill({ size, className, style }) {
  return (
    <IconWrapper size={size} className={className} style={style}>
      <path d="M6 10v8a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-8" />
      <path d="M12 4v6M9 7l3-3 3 3" />
    </IconWrapper>
  )
}

/** תרשים זרימה — סגנון Excalidraw */
export function IconFlow({ size, className, style }) {
  return (
    <IconWrapper size={size} className={className} style={style}>
      <rect x="2.5" y="3" width="7.5" height="5.5" rx="1.2" />
      <rect x="14" y="15.5" width="7.5" height="5.5" rx="1.2" />
      <path d="M6.5 8.5c3 1.5 6 3 9.5 7" />
      <path d="M18 14.5l2.2 1.5L18 17.5" />
    </IconWrapper>
  )
}

export function IconGlitter({ size, className, style }) {
  return (
    <IconWrapper size={size} className={className} style={style}>
      <path d="M12 3l1.5 4.5L18 9l-4.5 1.5L12 15l-1.5-4.5L6 9l4.5-1.5L12 3z" />
      <path d="M5 19l1.5-2 2 1.5-1.5 2-2-1.5z" />
      <path d="M19 17l-1 1.5 1.5 1 1-1.5-1.5-1z" />
    </IconWrapper>
  )
}

/** זריקת צבע / ספלאש (דפדפן) */
export function IconSplash({ size, className, style }) {
  return (
    <IconWrapper size={size} className={className} style={style}>
      <path fill="currentColor" stroke="none" d="M12 2.5c-1.8 3.2-4.8 6-4.8 9.3a4.8 4.8 0 1 0 9.6 0c0-3.3-3-6.1-4.8-9.3z" />
      <circle cx="17.2" cy="7.5" r="1.35" fill="currentColor" stroke="none" opacity="0.9" />
      <circle cx="19" cy="11.5" r="0.95" fill="currentColor" stroke="none" opacity="0.75" />
      <circle cx="5.8" cy="10" r="1.05" fill="currentColor" stroke="none" opacity="0.8" />
      <circle cx="7.5" cy="6.2" r="0.75" fill="currentColor" stroke="none" opacity="0.65" />
    </IconWrapper>
  )
}

export function IconPencil({ size, className, style }) {
  return (
    <IconWrapper size={size} className={className} style={style}>
      <path d="M17 3a2.85 2.85 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z" />
    </IconWrapper>
  )
}

export function IconMarker({ size, className, style }) {
  return (
    <IconWrapper size={size} className={className} style={style}>
      <path d="M12 2l2 4 4 .5-3 3.5.5 4L12 11l-3.5 3 .5-4L6 6.5l4-.5L12 2z" />
      <path d="M6 20l3-3 3 3-3 1-3-1z" />
    </IconWrapper>
  )
}

export function IconSmudge({ size, className, style }) {
  return (
    <IconWrapper size={size} className={className} style={style}>
      <path d="M6 10c0 2 1.5 4 4 4s4-2 4-4" stroke="currentColor" fill="none" strokeWidth="1.8" strokeLinecap="round" />
      <path d="M8 14c1 1 2 1 4 1s3 0 4-1" stroke="currentColor" fill="none" strokeWidth="1.5" strokeLinecap="round" opacity="0.85" />
      <circle cx="12" cy="8" r="2.5" fill="none" stroke="currentColor" strokeWidth="1.5" />
    </IconWrapper>
  )
}

// סגנונות צביעה — עיגול, חצי, כוכב, עיגול ריק, יהלום, עיגול עם נקודה
export function IconPaintNormal({ size, className, style }) {
  return (
    <IconWrapper size={size} className={className} style={style}>
      <circle cx="12" cy="12" r="6" fill="currentColor" />
    </IconWrapper>
  )
}

export function IconPaintMatte({ size, className, style }) {
  return (
    <IconWrapper size={size} className={className} style={style}>
      <path d="M12 4a8 8 0 0 1 0 16 8 8 0 0 1 0-16z" fill="currentColor" opacity="0.6" />
      <path d="M12 4v16M12 4a8 8 0 0 1 6.93 4" stroke="currentColor" fill="none" strokeWidth="1.5" />
    </IconWrapper>
  )
}

export function IconPaintGold({ size, className, style }) {
  return (
    <IconWrapper size={size} className={className} style={style}>
      <path d="M12 2l1.5 4.5L18 8l-4.5 1.5L12 14l-1.5-4.5L6 8l4.5-1.5L12 2z" fill="currentColor" />
    </IconWrapper>
  )
}

export function IconPaintPastel({ size, className, style }) {
  return (
    <IconWrapper size={size} className={className} style={style}>
      <circle cx="12" cy="12" r="6" fill="none" stroke="currentColor" strokeWidth="2" />
    </IconWrapper>
  )
}

export function IconPaintMetallic({ size, className, style }) {
  return (
    <IconWrapper size={size} className={className} style={style}>
      <path d="M12 4l4 8-4 8-4-8 4-8z" fill="none" stroke="currentColor" strokeWidth="2" />
      <path d="M4 12h16" stroke="currentColor" strokeWidth="2" />
    </IconWrapper>
  )
}

export function IconPaintNeon({ size, className, style }) {
  return (
    <IconWrapper size={size} className={className} style={style}>
      <circle cx="12" cy="12" r="7" fill="none" stroke="currentColor" strokeWidth="2" />
      <circle cx="12" cy="12" r="2" fill="currentColor" />
    </IconWrapper>
  )
}

export function IconPaintWatercolor({ size, className, style }) {
  return (
    <IconWrapper size={size} className={className} style={style}>
      <path d="M6 14q2-2 6-2 4 0 6 2" stroke="currentColor" fill="none" strokeWidth="1.8" strokeLinecap="round" opacity="0.9" />
      <path d="M8 12q2-2 4-2 2 0 4 2" stroke="currentColor" fill="none" strokeWidth="1.5" strokeLinecap="round" opacity="0.7" />
      <path d="M10 16q2 0 4 2" stroke="currentColor" fill="none" strokeWidth="1.5" strokeLinecap="round" opacity="0.6" />
    </IconWrapper>
  )
}

export function IconPaintOil({ size, className, style }) {
  return (
    <IconWrapper size={size} className={className} style={style}>
      <circle cx="12" cy="10" r="4" fill="currentColor" />
      <path d="M8 10h8M10 14h4" stroke="currentColor" fill="none" strokeWidth="1.2" opacity="0.8" />
    </IconWrapper>
  )
}

export function IconPaintAcrylic({ size, className, style }) {
  return (
    <IconWrapper size={size} className={className} style={style}>
      <rect x="6" y="6" width="12" height="12" rx="2" fill="none" stroke="currentColor" strokeWidth="2" />
      <path d="M6 12h12M12 6v12" stroke="currentColor" strokeWidth="1" opacity="0.7" />
    </IconWrapper>
  )
}

export function IconPaintCharcoal({ size, className, style }) {
  return (
    <IconWrapper size={size} className={className} style={style}>
      <path d="M6 18L8 8l4-2 4 2 2 10" stroke="currentColor" fill="none" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M8 14h8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" opacity="0.8" />
    </IconWrapper>
  )
}

export function IconEyedropper({ size, className, style }) {
  return (
    <IconWrapper size={size} className={className} style={style}>
      <path d="M4 20l8-8 4 4-8 8-4-4z" stroke="currentColor" fill="none" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M12 12l4-4 4 4-4 4-4-4z" stroke="currentColor" fill="none" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M16 8v2M18 10h2M16 12l2 2" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
    </IconWrapper>
  )
}

/** אייקון משתמש / שם — להצגה בחדר ציור */
export function IconUser({ size, className, style }) {
  return (
    <IconWrapper size={size} className={className} style={style}>
      <circle cx="12" cy="8" r="3.5" />
      <path d="M4 20c0-4 4-6 8-6s8 2 8 6" />
    </IconWrapper>
  )
}

/** דובי עם דגל — לתפריט במסך הפתיחה */
export function IconBearFlag({ size, className, style }) {
  return (
    <IconWrapper size={size} className={className} style={style}>
      {/* ראש דובי עגול */}
      <circle cx="12" cy="9.5" r="4.5" fill="#fef3c7" stroke="#78350f" strokeWidth="1.4" />
      {/* אוזניים */}
      <circle cx="9" cy="6.5" r="1.7" fill="#fef3c7" stroke="#78350f" strokeWidth="1.2" />
      <circle cx="15" cy="6.5" r="1.7" fill="#fef3c7" stroke="#78350f" strokeWidth="1.2" />
      <circle cx="9" cy="6.5" r="0.8" fill="#fde68a" stroke="none" />
      <circle cx="15" cy="6.5" r="0.8" fill="#fde68a" stroke="none" />
      {/* עיניים */}
      <circle cx="10.8" cy="9.2" r="0.45" fill="#111827" />
      <circle cx="13.2" cy="9.2" r="0.45" fill="#111827" />
      {/* לוע ואף */}
      <ellipse cx="12" cy="10.8" rx="1.9" ry="1.4" fill="#fee2b3" stroke="#78350f" strokeWidth="0.7" />
      <circle cx="12" cy="10.6" r="0.45" fill="#111827" />
      <path d="M11.2 11.3c.25.25.5.4.8.4.3 0 .55-.15.8-.4" fill="none" stroke="#b45309" strokeWidth="0.6" strokeLinecap="round" />
      {/* גוף / בובה */}
      <path
        d="M8.5 13.5c0-1.4 1.5-2.6 3.5-2.6s3.5 1.2 3.5 2.6v2.1c0 1.8-1.6 3.3-3.5 3.3s-3.5-1.5-3.5-3.3z"
        fill="#fed7aa"
        stroke="#b45309"
        strokeWidth="1"
      />
      {/* יד שמאל מחזיקה פלטה */}
      <path
        d="M9 13.8c-.9.2-1.6.9-1.8 1.7-.2.8.1 1.7.8 2.2"
        fill="none"
        stroke="#b45309"
        strokeWidth="0.9"
        strokeLinecap="round"
      />
      {/* פלטת צבעים */}
      <path
        d="M6.6 15.3c1.4-1.2 3.6-.9 4.7.6.7.9.7 2.1 0 2.9-.7.8-1.9.8-2.9.4-.9-.4-2.1-.8-2.5-2.1-.2-.7.1-1.4.7-1.8z"
        fill="#fef3c7"
        stroke="#78350f"
        strokeWidth="0.9"
      />
      {/* נקודות צבע על הפלטה */}
      <circle cx="8" cy="16" r="0.4" fill="#3b82f6" />
      <circle cx="9.2" cy="15.4" r="0.4" fill="#ec4899" />
      <circle cx="9.6" cy="16.7" r="0.4" fill="#22c55e" />
      {/* רגליים קטנות */}
      <ellipse cx="10" cy="18.5" rx="1.1" ry="0.8" fill="#f97316" stroke="#b45309" strokeWidth="0.6" />
      <ellipse cx="14" cy="18.5" rx="1.1" ry="0.8" fill="#f97316" stroke="#b45309" strokeWidth="0.6" />
    </IconWrapper>
  )
}

function getPaintIconMap() {
  return {
    normal: IconPaintNormal,
    matte: IconPaintMatte,
    gold: IconPaintGold,
    pastel: IconPaintPastel,
    metallic: IconPaintMetallic,
    neon: IconPaintNeon,
    watercolor: IconPaintWatercolor,
    oil: IconPaintOil,
    acrylic: IconPaintAcrylic,
    charcoal: IconPaintCharcoal,
  }
}

export function IconPaintStyle({ styleId, size, className, style }) {
  const Icon = getPaintIconMap()[styleId] || IconPaintNormal
  return <Icon size={size} className={className} style={style} />
}

/** לוגו האפליקציה — מברשת עם צבעים ונצנצים, למסך פתיחה */
export function AppLogo({ size = 80, className, style }) {
  const s = size
  return (
    <span
      className={`app-logo ${className || ''}`.trim()}
      style={{ display: 'inline-block', width: s, height: s, ...style }}
      aria-hidden
    >
      <svg width={s} height={s} viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <linearGradient id="logo-brush-handle" x1="0" y1="1" x2="0" y2="0">
            <stop offset="0%" stopColor="#8b6914"/>
            <stop offset="100%" stopColor="#d4a84b"/>
          </linearGradient>
          <linearGradient id="logo-bristles" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#ff6b6b"/>
            <stop offset="33%" stopColor="#feca57"/>
            <stop offset="66%" stopColor="#48dbfb"/>
            <stop offset="100%" stopColor="#ff9ff3"/>
          </linearGradient>
        </defs>
        {/* מברשת — ידית */}
        <path d="M38 18 L42 18 L44 52 L36 52 Z" fill="url(#logo-brush-handle)" stroke="rgba(0,0,0,0.15)" strokeWidth="0.6" strokeLinejoin="round"/>
        {/* מתכת */}
        <path d="M36 48 L44 48 L45 54 L35 54 Z" fill="#9ca3af"/>
        <path d="M35 54 L45 54 L44 58 L36 58 Z" fill="#6b7280"/>
        {/* סיבי המברשת — פסי צבע */}
        <path d="M34 58 L46 58 L48 72 L32 72 Z" fill="url(#logo-bristles)" stroke="rgba(0,0,0,0.1)" strokeWidth="0.5" strokeLinejoin="round"/>
        {/* נצנצים */}
        <path d="M22 24 L24 28 L28 28 L25 31 L26 36 L22 33 L18 36 L19 31 L16 28 L20 28 Z" fill="#fef08a" opacity="0.95"/>
        <path d="M56 20 L58 24 L62 24 L59 27 L60 32 L56 29 L52 32 L53 27 L50 24 L54 24 Z" fill="#fdd4b8" opacity="0.95"/>
        <path d="M18 52 L19.5 55 L23 55 L20.5 57 L21.5 61 L18 59 L14.5 61 L15.5 57 L13 55 L16.5 55 Z" fill="#a5f3fc" opacity="0.9"/>
        <path d="M62 48 L63.5 51 L67 51 L64.5 53 L65.5 57 L62 55 L58.5 57 L59.5 53 L57 51 L60.5 51 Z" fill="#f9a8d4" opacity="0.9"/>
        <circle cx="28" cy="14" r="2.5" fill="#fef08a" opacity="0.8"/>
        <circle cx="52" cy="12" r="2" fill="#fecaca" opacity="0.8"/>
      </svg>
    </span>
  )
}
